module.exports = __webpack_public_path__ + "img/assign-group-icon.f69aa537.svg";